import { postAllAvailability as postAllAvailabilityRequest } from 'MeetingsLib/api/availabilityAPI';
/**
 * @deprecated do not use this action - endpoint no longer exists
 */
export const postAllAvailability = data => (dispatch, getState, httpClient) => postAllAvailabilityRequest(httpClient, data);